@if (isLoading) {
<div class="position-relative w-100 h-100 d-flex align-items-center justify-content-center">
  <!-- Loading with Pastel Background (if bgClass exists) -->
  @if (bgClass) {
  <div [class]="cssStyle + ' ' + bgClass" class="d-flex align-items-center justify-content-center p-3 text-center"
    style="height: 100% !important;">
    <span class="text-wrap text-bookcover text-center w-100 opacity-50">
      {{ 'Loading' | translate }}
    </span>
  </div>
  } @else {
  <!-- Loading with No Image (if no bgClass) -->
  <div class="position-relative">
    <img src="assets/images/bookcover/noimage.jpg" alt="Loading" [class]="cssStyle + ' cover'" loading="lazy" />
    <span
      class="position-absolute top-50 start-50 translate-bookcover z-1 opacity-50 text-wrap text-bookcover text-center">
      {{ 'Loading' | translate }}
    </span>
  </div>
  }
</div>
} @else {
<div class="position-relative w-100 h-100 d-flex align-items-center justify-content-center">
  <!-- Image Present or Single Mode No-Image -->
  @if (isCover || !bgClass) {
  <img [src]="cover" [alt]="title" [class]="cssStyle" loading="lazy" (error)="imagerror($event)"
    (load)="imageLoaded($event)" />
  }

  <!-- Pastel Background (No Image + Multiple Mode) -->
  @if (!isCover && bgClass) {
  <div [class]="cssStyle + ' ' + bgClass" class="d-flex align-items-center justify-content-center p-3 text-center"
    style="height: 100% !important;">
    <span class="text-wrap text-bookcover text-center w-100 opacity-50 title-clamp-3">
      {{title}}
    </span>
  </div>
  }

  <!-- Title Overlay (Show if no image AND NOT pastel mode AND NOT custom mode) -->
  @if (!isCover && !bgClass && !isCustomNoImage) {
  <span
    class="position-absolute top-50 start-50 translate-bookcover z-1 opacity-50 text-wrap text-bookcover text-center w-100 px-3 py-2 title-clamp-3"
    style="background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(4px); border-radius: 8px; color: white;">
    {{title}}
  </span>
  }
</div>
}